<template>
  <div>
    <div class="mx-7">
      <v-btn
        text
        class="icon-btn"
        color="primary"
        @click="handleCancel"
      >
        <v-icon x-small>
          $faChevronLeft
        </v-icon>
        <span>{{ '\t' }}{{ propertyDetails.name }}</span>
      </v-btn>
    </div>
    <v-card
      id="zone-edit-details"
      class="px-7 pt-10 pb-5 mx-7 mt-0"
    >
      <h1 class="mb-7">
        Sensor Settings
      </h1>
      <div class="d-flex">
        <v-container id="image-container">
          <img
            width="100%"
            :src="zoneImage"
            :alt="selectedZone.name"
          >
        </v-container>
        <v-container id="zone-details">
          <v-form v-model="valid">
            <div
              id="icon-indicators"
              class="d-flex"
            >
              <div class="d-flex align-center">
                <span class="indicator"><v-icon
                  class="mr-2"
                  x-small
                  :color="selectedZone.status | colorConnection"
                >$faCircle</v-icon>{{ selectedZone.status }}</span>
              </div>
            </div>
            <v-text-field
              v-model="zoneName"
              filled
              dense
              label="Sensor Name"
              :rules="[val => !!val.trim() || 'Required']"
            />
            <v-select
              filled
              dense
              disabled
              :value="zoneLocation"
              append-icon="$faChevronUp"
              label="Location"
              :items="locations"
            />
            <div
              class="d-flex justify-space-between"
              style="width:430px"
            >
              <div>
                <div class="pb-2">
                  <h6>Sensor Type</h6>
                  <span class="pb-3">{{ sensorStyle | formatSensorType }}</span>
                </div>
                <div class="pb-2">
                  <h6>Gen/Revision</h6>
                  <span>
                    {{ sensorGenRevision }}
                  </span>
                </div>
                <div class="pb-2">
                  <h6>Firmware ID</h6>
                  <span class="pb-3">{{ sensorFirmwareId || 'Unknown' }}</span>
                </div>
              </div>
            </div>
            <div class="button-container">
              <v-btn
                text
                color="error"
                @click="handleDelete"
              >
                DELETE SENSOR
              </v-btn>
              <v-btn
                color="secondary"
                @click="handleCancel"
              >
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                :loading="submitting"
                :disabled="submitting || !valid || !changed"
                @click="handleSave"
              >
                Save
              </v-btn>
            </div>
          </v-form>
        </v-container>
      </div>
    </v-card>
  </div>
</template>
<script>
  import placeholder from '@/assets/ZonePlaceholder.png'
  import { mapGetters } from 'vuex'
  export default {
    name: 'ZoneEdit',
    filters: {
      colorConnection (val) {
        switch (val) {
          case 'ONLINE':
            return '#33A08E'
          case 'OFFLINE':
            return 'error'
          case 'INACTIVE':
          default:
            return 'gray'
        }
      },
      formatSensorType (val) {
        if (val) {
          return val.charAt(0).toUpperCase() + val.slice(1)
        } else {
          return 'Unknown'
        }
      },
    },
    data: () => ({
      locations: [],
      zoneImage: placeholder,
      zoneLocation: '',
      zoneName: '',
      valid: false,
      submitting: false,
    }),
    computed: {
      ...mapGetters({
        propertyDetails: 'Properties/propertyDetails',
        selectedZone: 'ActivityZones/selectedZone',
      }),
      changed () {
        return this.zoneName.trim() && this.selectedZone.name.trim() && this.zoneName.trim() !== this.selectedZone.name.trim()
      },
      sensorStyle () {
        return this.selectedZone.sensor?.style ?? ''
      },
      sensorGenRevision () {
        if (this.selectedZone.sensor?.generation && this.selectedZone.sensor?.rev) {
          return `${this.selectedZone.sensor.generation}/${this.selectedZone.sensor.rev}`
        }
        return 'N/A'
      },
      sensorFirmwareId () {
        return this.selectedZone.sensor?.firmwareId ?? ''
      },
    },
    mounted () {
      this.zoneLocation = this.propertyDetails.name
      this.zoneName = this.selectedZone.name
    },
    methods: {
      handleCancel () {
        this.$router.push({ path: `/properties/${this.propertyDetails.id}` })
      },
      handleDelete () {
        this.$root.$confirm({
          minHeight: 510,
          width: 400,
          title: 'Delete Sensor',
          text: `Are you sure you want to delete the sensor <span class="font-weight-bold">${this.selectedZone.name}</span> and all of its data?`,
          cancelText: 'CANCEL',
          confirmText: 'YES, DELETE',
          icon: '$faTrash',
        }).then(confirm => {
          const payload = { id: this.selectedZone.id, path: `/properties/${this.propertyDetails.id}` }
          this.$store.dispatch('ActivityZones/deleteZone', payload)
        })
      },
      handleSave () {
        this.submitting = true
        const payload = { id: this.selectedZone.id, name: this.zoneName.trim() }
        this.$store.dispatch('ActivityZones/updateZone', payload)
          .then(() => {
            const messagePayload = { type: 'success', text: 'Successfully updated activity zone' }
            this.$store.dispatch('updateMessages', messagePayload, { root: true })
            this.$router.push({ name: 'Property Details', params: { id: `${this.propertyDetails.id}` } })
          })
          .catch(() => {
            const messagePayload = { type: 'error', text: 'Oops! This zone could not be updated. Please try again.' }
            this.$store.dispatch('updateMessages', messagePayload, { root: true })
          })
          .finally(() => {
            this.submitting = false
          })
      },
    },
  }
</script>
<style lang="scss">
#image-container {
  width: 750px;
  border-radius: 4px;
  background-color: white;
}
#zone-details {
  width: 700px;
}
#icon-indicators {
  width:400px;
  margin-bottom:20px;
  .indicator {
    margin-right:42px;
    display:flex;
    align-items: center;
  }
}
.button-container {
  margin-top:100px;
  display:flex;
  justify-content: flex-end;
}
</style>
